import { useInvalidateAllConciseBranches } from '@festina-life/api'
import type { ConfigurableServer } from '@festina-life/core'
import { Button } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'
import { useState } from 'react'

import { BranchCreationWizardModal } from '../branchCreator/BranchCreationWizardModal'

type Props = {
  server: ConfigurableServer
}

export const CreateServerBranchButton = ({ server }: Props) => {
  const translate = useTranslate()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const invalidate = useInvalidateAllConciseBranches()

  const handleDidCreateBranch = () => {
    setIsModalOpen(false)
    invalidate()
  }

  return (
    <>
      <BranchCreationWizardModal
        onCreate={handleDidCreateBranch}
        onCancel={() => setIsModalOpen(false)}
        isOpen={isModalOpen}
        initialValues={{ server }}
      />
      <Button startIcon="Plus" onClick={() => setIsModalOpen(true)}>
        {translate('serverDetailsPanel.tabs.manage.createBranch')}
      </Button>
    </>
  )
}
